"use strict";

exports.__esModule = true;
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const ThirdPartyIcon = ({
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: 57,
  height: 53,
  viewBox: "0 0 57 53",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M28.803 2.273a3.34 3.34 0 00-3.337 3.337 3.34 3.34 0 003.337 3.336A3.34 3.34 0 0032.14 5.61a3.34 3.34 0 00-3.337-3.337m0 8.474a5.144 5.144 0 01-5.137-5.137A5.144 5.144 0 0128.803.472 5.144 5.144 0 0133.94 5.61a5.144 5.144 0 01-5.138 5.137",
    fill: "#4caa50",
    className: "svg-fill-primary"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M36.07 19.675h-1.691a.9.9 0 110-1.8h.79v-.63a6.374 6.374 0 00-6.366-6.366 6.373 6.373 0 00-6.366 6.366l.02.63h7.373a.9.9 0 010 1.8h-8.293a.9.9 0 01-.88-1.096c.009-.213-.003-.812-.02-1.302-.001-4.535 3.663-8.199 8.166-8.199s8.167 3.664 8.167 8.167v1.53a.9.9 0 01-.9.9",
    fill: "#4caa50",
    className: "svg-fill-primary"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M31.452 18.775a.766.766 0 111.532 0 .766.766 0 01-1.532 0",
    fill: "#4caa50",
    className: "svg-fill-primary"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M8.224 29.508a3.226 3.226 0 00-3.222 3.222 3.226 3.226 0 003.222 3.221 3.226 3.226 0 003.223-3.22 3.226 3.226 0 00-3.223-3.223m0 8.244a5.027 5.027 0 01-5.022-5.022 5.027 5.027 0 015.022-5.023 5.028 5.028 0 015.023 5.023 5.028 5.028 0 01-5.023 5.022",
    fill: "#fefefe",
    className: "svg-fill-secondary"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M2.073 44.64h12.322v-.588a6.177 6.177 0 00-6.171-6.17 6.177 6.177 0 00-6.17 6.17l.019.588m13.223 1.801H1.154a.9.9 0 01-.88-1.095c.008-.208-.003-.789-.02-1.263 0-4.426 3.576-8.003 7.97-8.003 4.396 0 7.972 3.577 7.972 7.972v1.488a.9.9 0 01-.9.901M42.624 44.64h12.322v-.588a6.177 6.177 0 00-6.17-6.17 6.177 6.177 0 00-6.17 6.17l.018.588m13.223 1.801H41.705a.9.9 0 01-.879-1.095c.007-.208-.004-.789-.02-1.263 0-4.426 3.575-8.003 7.97-8.003s7.971 3.577 7.971 7.972v1.488a.9.9 0 01-.9.901",
    fill: "#fefefe",
    className: "svg-fill-secondary"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M48.776 29.508a3.226 3.226 0 00-3.223 3.222 3.226 3.226 0 003.223 3.221 3.226 3.226 0 003.222-3.22 3.226 3.226 0 00-3.222-3.223m0 8.244a5.028 5.028 0 01-5.023-5.022 5.028 5.028 0 015.023-5.023 5.027 5.027 0 015.022 5.023 5.027 5.027 0 01-5.022 5.022",
    fill: "#fefefe",
    className: "svg-fill-secondary"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M28.556 52.01a16.384 16.384 0 01-3.745-.436 16.14 16.14 0 01-5.386-2.37.901.901 0 011.014-1.488 14.336 14.336 0 004.786 2.106 14.5 14.5 0 0010.08-1.277 14.4 14.4 0 002.24-1.463.899.899 0 111.119 1.41 16.23 16.23 0 01-5.238 2.777 16.227 16.227 0 01-4.87.741",
    fill: "#4caa50",
    className: "svg-fill-primary"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M37.893 52.15a.9.9 0 01-.895-1.007l.372-3.117-3.118-.372a.9.9 0 01.213-1.787l4.01.478a.9.9 0 01.788 1l-.477 4.011a.902.902 0 01-.893.794M55.204 25.157a.9.9 0 01-.883-.732 14.44 14.44 0 00-1.895-4.874 14.621 14.621 0 00-3.435-3.826 14.45 14.45 0 00-4.598-2.4 14.356 14.356 0 00-2.617-.548.902.902 0 01-.792-.997.904.904 0 01.997-.792c.997.114 1.988.322 2.945.617a16.31 16.31 0 019.03 7 16.13 16.13 0 012.132 5.485.898.898 0 01-.884 1.067",
    fill: "#4caa50",
    className: "svg-fill-primary"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M43.802 16.158a.898.898 0 01-.707-.344l-2.498-3.174a.899.899 0 01.15-1.263L43.92 8.88a.9.9 0 111.113 1.414l-2.466 1.941 1.94 2.467a.9.9 0 01-.706 1.457M6.1 24.23a.902.902 0 01-.896-1.003 16.184 16.184 0 011.744-5.669 16.372 16.372 0 015.875-6.307 16.255 16.255 0 015.483-2.132.899.899 0 11.336 1.767 14.41 14.41 0 00-6.94 3.445 14.539 14.539 0 00-3.16 4.062 14.328 14.328 0 00-1.547 5.04.902.902 0 01-.894.797",
    fill: "#4caa50",
    className: "svg-fill-primary"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M6.302 24.805a.894.894 0 01-.707-.344l-2.498-3.175a.899.899 0 111.414-1.113l1.94 2.468 2.468-1.94a.9.9 0 111.113 1.413l-3.173 2.498a.9.9 0 01-.557.193",
    fill: "#4caa50",
    className: "svg-fill-primary"
  })]
});

ThirdPartyIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(ThirdPartyIcon);

exports.default = _default;